import * as Yup from 'yup';
import httpCommon from 'src/http-common';
import { getClientConfig } from './clientSelector';

// Helper function to get endpoints at runtime
const getEndpoints = () => {
  const { endpoints } = getClientConfig();
  return endpoints;
};

// API Services

//NOTE - ==================== STANDARD - REQUEST BY NEW BUTTON ====================
/**
 * Fetch user information for work request creation
 */
export const getUserInfo = async ({ site_cd, login_id, mst_rowID, isCreatingWorkReq, workRequestNumber }) => {
  const endpoints = getEndpoints();
  const response = await httpCommon.get(endpoints.getUserInfo(site_cd, login_id, mst_rowID, isCreatingWorkReq, workRequestNumber));
  return response;
};

/**
 * Fetch work area dropdown options
 */
export const getWorkAreaDropdown = async (site_cd) => {
  const endpoints = getEndpoints();
  const response = await httpCommon.get(endpoints.getWorkAreaDropdown(site_cd));
  return response;
};

/**
 * Fetch priority dropdown options
 */
export const getPriorityDropdown = async (site_cd) => {
  const endpoints = getEndpoints();
  const response = await httpCommon.get(endpoints.getPriorityDropdown(site_cd));
  return response;
};

/**
 * Fetch level dropdown options based on work area
 */
export const getLevelDropdown = async (site_cd, wrk_Ara) => {
  const endpoints = getEndpoints();
  const response = await httpCommon.get(endpoints.getLevelDropdown(site_cd, wrk_Ara));
  return response;
};

/**
 * Fetch work group dropdown options
 */
export const getWorkGroupDropdown = async (site_cd) => {
  const endpoints = getEndpoints();
  const response = await httpCommon.get(endpoints.getWorkGroupDropdown(site_cd));
  return response;
};

/**
 * Fetch asset number dropdown options
 */
export const getAssetNumberDropdown = async (site_cd, ast_lvl, wrk_Ara, asset_locn) => {
  const endpoints = getEndpoints();
  const response = await httpCommon.get(endpoints.getAssetNumberDropdown(site_cd, ast_lvl, wrk_Ara, asset_locn));
  return response;
};

/**
 * Fetch asset location dropdown options
 */
export const getAssetLocationDropdown = async (site_cd, ast_lvl, wrk_Ara) => {
  const endpoints = getEndpoints();
  const response = await httpCommon.get(endpoints.getAssetLocationDropdown(site_cd, ast_lvl, wrk_Ara));
  return response;
};

/**
 * Fetch fault code dropdown options
 */
export const getFaultCodeDropdown = async (site_cd) => {
  const endpoints = getEndpoints();
  const response = await httpCommon.get(endpoints.getFaultCodeDropdown(site_cd));
  return response;
};

/**
 * Fetch asset details by QR code scan
 */
export const getAssetNumberUsingScanQR = async (site_cd, asset_no) => {
  const endpoints = getEndpoints();
  const response = await httpCommon.get(endpoints.getAssetNumberUsingScanQR(site_cd, asset_no));
  return response;
};

/**
 * Create new work request
 */
export const createWorkRequest = async (formData) => {
  const endpoints = getEndpoints();
  const response = await httpCommon.post(endpoints.createWorkRequest(), formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response;
};

//NOTE - ==================== SMCD CUSTOMIZATION - REQUEST BY DEPARTMENT ====================
export const getUserInfoByDepartment = async ({ site_cd, login_id, mst_rowID, isCreatingWorkReq, workRequestNumber }) => {
  const endpoints = getEndpoints();
  // For SMCD, use getUserInfo endpoint if getUserInfoByDepartment doesn't exist
  const endpointFn = endpoints.getUserInfoByDepartment || endpoints.getUserInfo;
  const response = await httpCommon.get(endpointFn(site_cd, login_id, mst_rowID, isCreatingWorkReq, workRequestNumber));
  return response;
};

/**
 * Fetch department dropdown options
 */
export const getDepartmentDropdownByDepartment = async (site_cd, services) => {
  const endpoints = getEndpoints();
  const response = await httpCommon.get(endpoints.getDepartmentDropdownByDepartment(site_cd, services));
  return response;
};

/**
 * Fetch priority dropdown options
 */
export const getPriorityDropdownByDepartment = async (site_cd) => {
  const endpoints = getEndpoints();
  // Check if endpoint exists (it's commented out in SMCD config)
  if (!endpoints.getPriorityDropdownByDepartment) {
    throw new Error('getPriorityDropdownByDepartment endpoint not available for this client');
  }
  const response = await httpCommon.get(endpoints.getPriorityDropdownByDepartment(site_cd));
  return response;
};

/**
 * Fetch level dropdown options based on work area
 */
export const getLevelDropdownByDepartment = async (site_cd, wrk_Ara, services) => {
  const endpoints = getEndpoints();
  const response = await httpCommon.get(endpoints.getLevelDropdownByDepartment(site_cd, wrk_Ara, services));
  return response;
};

/**
 * Fetch services dropdown options
 */
export const getServicesDropdownByDepartment = async (site_cd) => {
  const endpoints = getEndpoints();
  const response = await httpCommon.get(endpoints.getServicesDropdownByDepartment(site_cd));
  return response;
};

/**
 * Fetch request classification dropdown options
 */
export const getRequestClassificationDropdownByDepartment = async (site_cd,gs_foreman) => {
  const endpoints = getEndpoints();
  const response = await httpCommon.get(endpoints.getRequestClassificationDropdownByDepartment(site_cd,gs_foreman));
  return response;
};

/**
 * Fetch asset number dropdown options
 */
export const getAssetNumberDropdownByDepartment = async (site_cd, ast_area, ast_locn, ast_group) => {
  const endpoints = getEndpoints();
  const response = await httpCommon.get(endpoints.getAssetNumberDropdownByDepartment(site_cd, ast_area, ast_locn, ast_group));
  return response;
};

/**
 * Fetch asset location dropdown options
 */
export const getAssetLocationDropdownByDepartment = async (site_cd, ast_lvl, wrk_Ara) => {
  const endpoints = getEndpoints();
  const response = await httpCommon.get(endpoints.getAssetLocationDropdownByDepartment(site_cd, ast_lvl, wrk_Ara));
  return response;
};

/**
 * Fetch fault code dropdown options
 */
export const getFaultCodeDropdownByDepartment = async (site_cd, services) => {
  const endpoints = getEndpoints();
  const response = await httpCommon.get(endpoints.getFaultCodeDropdownByDepartment(site_cd, services));
  return response;
};

/**
 * Fetch asset details by QR code scan
 */
export const getAssetNumberUsingScanQRByDepartment = async (site_cd, asset_no) => {
  const endpoints = getEndpoints();
  // Check if endpoint exists (it's commented out in SMCD config)
  if (!endpoints.getAssetNumberUsingScanQRByDepartment) {
    throw new Error('getAssetNumberUsingScanQRByDepartment endpoint not available for this client');
  }
  const response = await httpCommon.get(endpoints.getAssetNumberUsingScanQRByDepartment(site_cd, asset_no));
  return response;
};

/**
 * Create new work request
 */
export const createWorkRequestByDepartment = async (formData) => {
  const endpoints = getEndpoints();
  const response = await httpCommon.post(endpoints.createWorkRequestByDepartment(), formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response;
};

//NOTE - ==================== SMCD CUSTOMIZATION - REQUEST BY LOCATION ====================
export const getUserInfoByLocation = async ({ site_cd, login_id, mst_rowID, isCreatingWorkReq, workRequestNumber }) => {
  const endpoints = getEndpoints();
  // For SMCD, use getUserInfo endpoint if getUserInfoByLocation doesn't exist
  const endpointFn = endpoints.getUserInfoByLocation || endpoints.getUserInfo;
  const response = await httpCommon.get(endpointFn(site_cd, login_id, mst_rowID, isCreatingWorkReq, workRequestNumber));
  return response;
};

/**
 * Fetch services dropdown options
 */
export const getServicesDropdownByLocation = async (site_cd) => {
  const endpoints = getEndpoints();
  const response = await httpCommon.get(endpoints.getServicesDropdownByLocation(site_cd));
  return response;
};

/**
 * Fetch level dropdown options
 */
export const getLevelDropdownByLocation = async (site_cd, services) => {
  const endpoints = getEndpoints();
  const response = await httpCommon.get(endpoints.getLevelDropdownByLocation(site_cd, services));
  return response;
};

/**
 * Fetch room / sub area dropdown options
 */
export const getRoomSubAreaDropdownByLocation = async (site_cd, level, services) => {
  const endpoints = getEndpoints();
  const response = await httpCommon.get(endpoints.getRoomSubAreaDropdownByLocation(site_cd, level, services));
  return response;
};

/**
 * Fetch priority dropdown options
 */
export const getPriorityDropdownByLocation = async (site_cd) => {
  const endpoints = getEndpoints();
  // Check if endpoint exists (it's commented out in SMCD config)
  if (!endpoints.getPriorityDropdownByLocation) {
    throw new Error('getPriorityDropdownByLocation endpoint not available for this client');
  }
  const response = await httpCommon.get(endpoints.getPriorityDropdownByLocation(site_cd));
  return response;
};

/**
 * Fetch asset number dropdown options
 */
export const getAssetNumberDropdownByLocation = async (site_cd, ast_lvl, wrk_Ara, asset_locn) => {
  const endpoints = getEndpoints();
  const response = await httpCommon.get(endpoints.getAssetNumberDropdownByLocation(site_cd, ast_lvl, wrk_Ara, asset_locn));
  return response;
};

/**
 * Fetch asset location dropdown options
 */
export const getAssetLocationDropdownByLocation = async (site_cd, ast_lvl, wrk_Ara) => {
  const endpoints = getEndpoints();
  const response = await httpCommon.get(endpoints.getAssetLocationDropdownByLocation(site_cd, ast_lvl, wrk_Ara));
  return response;
};

/**
 * Fetch fault code dropdown options
 */
export const getFaultCodeDropdownByLocation = async (site_cd, services) => {
  const endpoints = getEndpoints();
  const response = await httpCommon.get(endpoints.getFaultCodeDropdownByLocation(site_cd, services));
  return response;
};

/**
 * Fetch request classification dropdown options
 */
export const getRequestClassificationDropdownByLocation = async (site_cd,gs_foreman) => {
  const endpoints = getEndpoints();
  const response = await httpCommon.get(endpoints.getRequestClassificationDropdownByLocation(site_cd,gs_foreman));
  return response;
};

/**
 * Fetch asset details by QR code scan
 */
export const getAssetNumberUsingScanQRByLocation = async (site_cd, asset_no) => {
  const endpoints = getEndpoints();
  // Check if endpoint exists (it's commented out in SMCD config)
  if (!endpoints.getAssetNumberUsingScanQRByLocation) {
    throw new Error('getAssetNumberUsingScanQRByLocation endpoint not available for this client');
  }
  const response = await httpCommon.get(endpoints.getAssetNumberUsingScanQRByLocation(site_cd, asset_no));
  return response;
};

/**
 * Create new work request
 */
export const createWorkRequestByLocation = async (formData) => {
  const endpoints = getEndpoints();
  const response = await httpCommon.post(endpoints.createWorkRequestByLocation(), formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response;
};
// ==================== Validation Schemas ====================

export const NewUserSchema2 = Yup.object().shape({
  wkr_mst_work_area: Yup.string().required('Work Area is required'),
  wkr_mst_location: Yup.string().required('Level is required'),
  wkr_mst_assetno: Yup.string().required('Asset Number is required'),
  wkr_mst_assetlocn: Yup.string().required('Asset Location is Required'),
  wkr_mst_work_group: Yup.string().required('Work group is required'),
  wkr_mst_orig_priority: Yup.string(),
  wkr_mst_fault_code: Yup.string().required('Fault Code is required'),
  wkr_mst_wr_descs: Yup.string().required('Request Description is required'),
  status: Yup.string(),
  isVerified: Yup.boolean(),
});

export const NewUserSchema = Yup.object().shape({
  gs_empl_id: Yup.string(),
  em_name: Yup.string().required('Name is required'),
  department: Yup.string().required('Department is required'),
  emp_mst_homephone: Yup.string().required('Contact number is required'),
  wkr_mst_email: Yup.string().required('Email is required'),
  status: Yup.string(),
  isVerified: Yup.boolean(),
});

// ==================== Initial States ====================

export const INITIAL_LOADING_LABELS = {
  workArea: false,
  level: false,
  assetLocation: false,
  assetNumber: false,
  faultCode: false,
  priority: false,
  workGroup: false,
};

// ==================== Constants ====================

export const MAX_FILES = 3; // Maximum total files (videos + images combined)
export const MAX_IMAGES = 3;
export const MAX_IMAGE_SIZE = 3145728; // 3MB
export const IMAGE_LIMIT_ERROR_MESSAGE = `You can only select up to ${MAX_IMAGES} photos.`;
export const ERROR_MESSAGE_TIMEOUT = 6000;

// Video upload constants
export const MAX_VIDEOS = 1;
export const MAX_VIDEO_SIZE = 30 * 1024 * 1024; // 30MB (before compression)
export const MAX_VIDEO_DURATION = 30; // 30 seconds
export const VIDEO_LIMIT_ERROR_MESSAGE = `You can only select up to ${MAX_VIDEOS} video.`;
export const VIDEO_DURATION_ERROR_MESSAGE = `Video file exceeds the maximum duration of ${MAX_VIDEO_DURATION} seconds.`;
export const FILE_LIMIT_ERROR_MESSAGE = `You can upload a maximum of ${MAX_FILES} files total (any combination of videos and images).`;

// ==================== Form Field Names ====================

export const FORM_FIELDS = {
  WORK_AREA: 'wkr_mst_work_area',
  LOCATION: 'wkr_mst_location',
  ASSET_NO: 'wkr_mst_assetno',
  ASSET_LOCATION: 'wkr_mst_assetlocn',
  WORK_GROUP: 'wkr_mst_work_group',
  FAULT_CODE: 'wkr_mst_fault_code',
  DESCRIPTION: 'wkr_mst_wr_descs',
  IMAGES: 'images',
  FILE: 'file',
  NAME: 'em_name',
  DEPARTMENT: 'department',
  PHONE: 'emp_mst_homephone',
  EMAIL: 'wkr_mst_email',
};

// ==================== Messages ====================

export const SUCCESS_MESSAGES = {
  WORK_REQUEST_CREATED: 'Your work request was created successfully',
};

export const ERROR_MESSAGES = {
  INVALID_EMAIL: 'Invalid email address.',
  FAILED_TO_FETCH: 'Failed to fetch data.',
  INVALID_ASSET_NO: 'Invalid Asset No.',
};
